import React from 'react';

const Logo: React.FC<{ className?: string; onClick?: () => void }> = ({ className = '', onClick }) => (
  <div className={className} onClick={onClick}>
    <img 
      src="/substans.svg" 
      alt="Substans Logo" 
      className="w-full h-full" 
      aria-label="substans"
    />
  </div>
);

export default Logo;